<div class="material-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
    
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h1 class="mat-headline-2" i18n>Snap&Sell</h1>
        <h1 i18n>The revolutionary solution to sell with minimal effort</h1>
        <p i18n>No need to fill in forms or to decide which photos to take. Just take a photo of the item you want to sell and our AI helps you with  the rest.</p>
      </div>

      <div class="screenshot mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
        <div style="position: relative; width: 224px; height: 450px;">
          <img-with-placeholder [placeholder]="'/snap-and-sell-ad/1_placeholder.webp' | assetUrl">
            <img fullSizedImage ngSrc="/snap-and-sell-ad/1.webp" height="450" width="224"/>
          </img-with-placeholder>
        </div>
      </div>
      <div class="screenshot mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
        <div style="position: relative; width: 224px; height: 450px;">
          <img-with-placeholder [placeholder]="'/snap-and-sell-ad/2_placeholder.webp' | assetUrl">
            <img fullSizedImage ngSrc="/snap-and-sell-ad/2.webp" height="450" width="224" loading="lazy"/>
          </img-with-placeholder>
        </div>
      </div>
      <div class="screenshot mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
        <div style="position: relative; width: 224px; height: 450px;">
          <img-with-placeholder [placeholder]="'/snap-and-sell-ad/3_placeholder.webp' | assetUrl">
            <img fullSizedImage ngSrc="/snap-and-sell-ad/3.webp" height="450" width="224" loading="lazy"/>
          </img-with-placeholder>
        </div>
      </div>
      <div class="screenshot mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
        <div style="position: relative; width: 224px; height: 450px;">
          <img-with-placeholder [placeholder]="'/snap-and-sell-ad/4_placeholder.webp' | assetUrl">
            <img fullSizedImage ngSrc="/snap-and-sell-ad/4.webp" height="450" width="224" loading="lazy"/>
          </img-with-placeholder>
        </div>
      </div>
          
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <p i18n>Give unused things a new life and help save the planet, one item at a time</p>
        <div class="button-panel">
          <button 
              type="button" 
              mat-raised-button
              color="accent"
              routerLink="/snap-and-sell"
              angulartics2On="click" 
              angularticsAction="TrySnapAndSellNowClick"
              i18n>
            TRY SNAP&SELL NOW
          </button>
        </div>
      </div>
      
    </div>
  </div>
</div>